<!--关闭工单弹窗-->
<template>
	<div class="addNewOwnerDialogBody">
		<!--新增业主-->
		<el-dialog :title="title" :visible.sync="show">
			<div style="display: flex;width: 100%;">
				<div class="dialog-from" style="width:70%">
					<el-form>
						<el-form-item label="生产（吨）" :label-width="formLabelWidth" :required="true">
							<el-input v-model="capacity" autocomplete="off" placeholder="请输入生产数量" type="number"></el-input>
						</el-form-item>
						<el-form-item label="发布周期：" :label-width="formLabelWidth" enable="false">
							<label for="c3">3个月</label>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>-

<script>
	import electricMeterTree from '@/components/module/meterReading/electricMeterTree.vue'
	import ownerManagerStore from '@/page/system/meterReading/ownerManagerStore.js'
	export default {
		components: {
			electricMeterTree,
		},
		props: {

		},
		data() {
			return {
				formLabelWidth: '130px',
				show: false,
				title: '',
				id: '',
				capacity: '',
				isEdit: true, //是否为编辑
			}
		},
		created() {
		},
		mounted() {},
		destroyed() {},
		computed: {
		},
		watch: {},
		methods: {
			confirm() {
				if(this.capacity.length == 0) {
					this.$message.error('请输入产量（吨）');
					return
				}
				this.$api.ningboApi.closeWorkorder(
					this.id, 
					this.capacity,
					'0',
					respon => {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.$emit("closeSuccess")
						this.show = false
					}, failure => {
						this.$message({
							type: 'error',
							message: failure
						});
					}
				)
			},
		}
	}
</script>

<style>
	.addNewOwnerDialogBody {
		/*width: 100%;
		 height: 100%;*/
	}
	
	.addNewOwnerDialogBody .dialog-from {
		width: calc(100% - 3.3rem);
		height: 100%;
	}
	
	.dialog-device {
		height: 710px;
		margin-left: 40px;
	}
	
	.addNewOwnerDialogBody .el-dialog__body {
		display: flex;
		align-items: center;
		padding: 0;
	}
</style>